<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Instrumentation</div>
    <div class="divider"></div>

    <div class="dates">
      <div class="date start-date">
        <div class="text">Start</div>
        <button
          mat-button
          class="icon-btn"
          (click)="startDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #startDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="startDate"
          (change)="onDateChanges()"
        >
        </lhpe-datepicker>
      </div>
      <div class="date end-date">
        <div class="text">End</div>
        <button
          mat-button
          class="icon-btn"
          (click)="endDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #endDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="endDate"
          (change)="onDateChanges()"
        >
        </lhpe-datepicker>
      </div>
    </div>

    <div class="divider"></div>

    <div class="filter">
      <button mat-button class="icon-btn" [matMenuTriggerFor]="baselineMenu">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div>
    <mat-menu class="baseline-mat-menu vertical-menu" #baselineMenu="matMenu">
      Comparative baseline:

      <mat-radio-group
        class="baseline-radio-group"
        [formControl]="baselineFormControl"
      >
        <mat-radio-button
          *ngFor="let baselineOption of baselineOptions"
          [value]="baselineOption.value"
          class="mat-lightGreen"
        >
          {{ baselineOption.name }}
        </mat-radio-button>
      </mat-radio-group>
    </mat-menu>
  </div>
  <div class="header-right">
    <button
      mat-button
      color="lightGreen"
      *ngIf="!createNewPanelDisabled"
      (click)="createNewPanel()"
    >
      Create New Panel
    </button>
  </div>
</div>
<div class="instrumentation">
  <div class="container-group">
    <div
      *ngFor="let accountAppInstrument of accountsAppInstruments"
      class="container instrumentation-container"
    >
      <div class="container-header no-bottom-border">
        <div *ngIf="!accountAppInstrument.showSwapPanel" class="text">
          {{ accountAppInstrument.account.name }}
          <b *ngIf="baseline !== 'industry'"
            >compared to prior {{ baseline }}-day period</b
          >
          <b *ngIf="baseline === 'industry'">compared to industry period</b>
        </div>

        <div
          *ngIf="accountAppInstrument.showSwapPanel"
          class="input-box client-swap"
        >
          <mat-form-field class="select-form">
            <mat-label>Select client to swap to</mat-label>
            <mat-select
              (selectionChange)="swapPanel($event, accountAppInstrument)"
            >
              <mat-option
                *ngFor="let account of accountsWithNoPanel"
                [value]="account"
                >{{ account.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="accountsMenu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu
            class="mat-menu-elaphant vertical-menu"
            #accountsMenu="matMenu"
          >
            <ng-container *ngIf="!accountAppInstrument.showSwapPanel">
              <button
                class="icon-btn-w-text"
                mat-menu-item
                *ngIf="!createNewPanelDisabled"
                (click)="createNewPanel()"
              >
                <svg-icon
                  src="assets/svg/plus-circle-white.svg"
                  svgClass="white"
                ></svg-icon>
                <span>Create new panel</span>
              </button>
              <button
                class="icon-btn-w-text"
                mat-menu-item
                *ngIf="!createNewPanelDisabled"
                (click)="showSwapPanel(accountAppInstrument)"
              >
                <svg-icon
                  src="assets/svg/reload.svg"
                  svgClass="white"
                ></svg-icon>
                <span>Swap panel</span>
              </button>
              <button
                class="icon-btn-w-text"
                mat-menu-item
                *ngIf="accountsAppInstruments.length !== 1"
                (click)="closePanel(accountAppInstrument)"
              >
                <svg-icon
                  src="assets/svg/x-circle.21.5.svg"
                  [svgStyle]="{
                    'width.px': '21.5',
                    'height.px': '21.5'
                  }"
                  svgClass="white"
                ></svg-icon>
                <span>Close panel</span>
              </button>
            </ng-container>
            <ng-container *ngIf="accountAppInstrument.showSwapPanel">
              <button
                class="icon-btn-w-text"
                mat-menu-item
                (click)="cancelSwapPanel(accountAppInstrument)"
              >
                <svg-icon
                  src="assets/svg/x-circle.21.5.svg"
                  [svgStyle]="{
                    'width.px': '21.5',
                    'height.px': '21.5'
                  }"
                  svgClass="white"
                ></svg-icon>
                <span>Cancel swap</span>
              </button>
            </ng-container>
          </mat-menu>
        </div>
      </div>

      <div class="container-content">
        <div class="instruments">
          <div
            *ngFor="
              let appInstrument of accountAppInstrument.appInstrumentations
            "
            class="instrument"
          >
            <div class="instrument-header">
              <div class="title">{{ appInstrument.instrument.name }}</div>
              <div class="options">
                <button mat-icon-button [matMenuTriggerFor]="instrumentMenu">
                  <svg-icon src="assets/svg/ellipsis-vert.svg"></svg-icon>
                </button>
                <mat-menu class="instrument-menu" #instrumentMenu="matMenu">
                  <div class="instrument-menu-body">
                    <div class="heading">Remove instrument</div>
                    <div
                      class="remove-instrument"
                      (click)="
                        removeInstrument(appInstrument, accountAppInstrument)
                      "
                    >
                      <div class="icon">
                        <svg-icon
                          src="assets/svg/instrument/remove.svg"
                        ></svg-icon>
                      </div>
                      <div class="text">
                        Remove {{ appInstrument.instrument.name }}
                      </div>
                    </div>
                    <div class="heading">Swap instrument</div>
                    <div class="instrument-groups">
                      <div
                        *ngFor="
                          let instrumentGroup of accountAppInstrument.instrumentGroups
                        "
                        class="instrument-group"
                      >
                        <div class="heading">
                          {{ instrumentGroup.name }}
                        </div>

                        <div class="content">
                          <div
                            *ngFor="
                              let instrument of instrumentGroup.instruments
                            "
                            class="instrument-type"
                            [ngClass]="{ selected: instrument.selected }"
                            (click)="
                              swapInstrument(
                                instrument,
                                appInstrument,
                                accountAppInstrument
                              )
                            "
                          >
                            <div class="icon">
                              <div *ngIf="instrument.selected">
                                <svg-icon
                                  src="assets/svg/instrument/selected.svg"
                                ></svg-icon>
                              </div>

                              <svg-icon
                                *ngIf="!instrument.selected"
                                src="assets/svg/instrument/swap.svg"
                              ></svg-icon>
                            </div>
                            <div class="text">{{ instrument.name }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-menu>
              </div>
            </div>
            <div
              class="instrument-content"
              [ngClass]="{ date: appInstrument.isDate }"
            >
              <div class="instrument-icon">
                <svg-icon
                  src="assets/svg/instrument/{{
                    appInstrument.instrument.icon
                  }}.svg"
                ></svg-icon>
              </div>
              <div class="value">
                <div class="text">{{ appInstrument.value }}</div>
                <div *ngIf="appInstrument.showChange" class="change">
                  {{ appInstrument.change }}%

                  <svg-icon
                    id="{{ appInstrument.id }}-change-icon"
                    src="assets/svg/instrument/change.svg"
                  ></svg-icon>
                </div>
              </div>
            </div>

            <div class="status-color {{ appInstrument.color }}"></div>
          </div>
          <div
            *ngIf="
              availableInstruments.length >
              accountAppInstrument.appInstrumentations.length
            "
            class="add-instrument"
          >
            <button mat-icon-button [matMenuTriggerFor]="addInstrumentMenu">
              <fa-icon [icon]="faPlus"></fa-icon>
            </button>
            <mat-menu class="instrument-menu" #addInstrumentMenu="matMenu">
              <div class="instrument-menu-body">
                <div class="heading">Add instrument</div>
                <div class="instrument-groups">
                  <div
                    *ngFor="
                      let instrumentGroup of accountAppInstrument.instrumentGroups
                    "
                    class="instrument-group"
                  >
                    <div class="heading">
                      {{ instrumentGroup.name }}
                    </div>

                    <div class="content">
                      <div
                        *ngFor="let instrument of instrumentGroup.instruments"
                        class="instrument-type"
                        [ngClass]="{ selected: instrument.selected }"
                        (click)="
                          addInstrument(instrument, accountAppInstrument)
                        "
                      >
                        <div class="icon">
                          <div *ngIf="instrument.selected">
                            <svg-icon
                              src="assets/svg/instrument/selected.svg"
                            ></svg-icon>
                          </div>

                          <svg-icon
                            *ngIf="!instrument.selected"
                            src="assets/svg/instrument/insert.svg"
                          ></svg-icon>
                        </div>
                        <div class="text">{{ instrument.name }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="createNewPanelOpen"
      class="container instrumentation-container add-instruemntation-container"
    >
      <div class="container-header no-bottom-border">
        <lhpe-select
          controlName="addPanel"
          placeholder="Select client"
          [formGroup]="panelForm!"
          [optionIsSelf]="true"
          displayValue="name"
          [options]="accountsWithNoPanel"
        >
        </lhpe-select>
        <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="newPanelMenu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu
            class="mat-menu-elaphant vertical-menu"
            #newPanelMenu="matMenu"
          >
            <button
              class="icon-btn-w-text"
              mat-menu-item
              (click)="removeNewPanel()"
            >
              <svg-icon
                src="assets/svg/x-circle.21.5.svg"
                [svgStyle]="{
                  'width.px': '21.5',
                  'height.px': '21.5'
                }"
                svgClass="white"
              ></svg-icon>
              <span>Close panel</span>
            </button>
          </mat-menu>
        </div>
      </div>

      <div class="container-content">
        <div class="new-instruments">
          <div
            *ngFor="let instrument of availableInstruments"
            class="new-instrument"
          >
            <div class="new-instrument-header">
              <div class="title">{{ instrument.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
